import { aggregationsAtom } from '@core/Atoms/Search/AggregationsAtom';
import { Tenant } from '@core/Entities/App/Tenants.entity';
import { Locale } from '@core/Entities/Locale/Locale.entity';
import { FilterParams } from '@core/Entities/Search/QueryParams.entity';
import { useAtom } from 'jotai';

import { Logos } from 'Components/SearchWidget/Components/MakeLabel/Logos';
import MakeLabel from 'Components/SearchWidget/Components/MakeLabel/MakeLabel';

import { useFilterLink } from 'Hooks/SearchFilters/UseFilterLink';
import { useSearchFilter } from 'Hooks/SearchFilters/UseSearchFilter';

import { FilterLink } from '../FilterLink/FilterLink';

import { POPULAR_MAKES_FR, POPULAR_MAKES_UK } from './MakeFilter.constants';

const filterId: keyof FilterParams = 'make';

function useMakeFilter(
  locale: Locale,
  isPlpFiltersSeoEnabled: boolean,
  tenant: Tenant | undefined,
  applyButton?: boolean,
) {
  const [{ makes }] = useAtom(aggregationsAtom);
  const { getLinkForFilterValue } = useFilterLink({
    filterId,
    locale,
    isPlpFiltersSeoEnabled,
    tenant,
  });

  const allMakes = makes.map(make => {
    const maybeLink = getLinkForFilterValue({
      filterValue: make.key,
      resultCount: make.count ?? 0,
    });

    return {
      id: make.key,
      renderLabel: (
        <MakeLabel
          count={make.count}
          make={make.make as Logos}
          name={make.displayName}
          nameRender={<FilterLink link={maybeLink}>{make.displayName}</FilterLink>}
        />
      ),
      label: make.displayName,
    };
  });

  const { allOptions, ...rest } = useSearchFilter({
    filterId,
    data: allMakes,
    applyButton,
  });

  const POPULAR_MAKES = locale === 'fr' ? POPULAR_MAKES_FR : POPULAR_MAKES_UK;
  const popularMakes = allOptions.filter(make => POPULAR_MAKES.includes(make.id));

  return {
    popularMakes,
    allMakes: allOptions,
    ...rest,
  };
}

export default useMakeFilter;
